module.exports = __webpack_public_path__ + "img/normal_multiplier.3596448c.png";